// import node module libraries
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";

// import popup youtube video
import ModalVideo from "react-modal-video";

// import media files
// import Frame1 from "assets/images/background/acedamy-img/frame-1.svg";
// import Frame2 from "assets/images/background/acedamy-img/frame-2.svg";
import GasStation from "assets/images/hero/GasStation.png";
// import PlayBtn from "assets/images/svg/play-btn.svg";

const HeroAcademy = () => {
  const [isOpen, setOpen] = useState(false);
  const [YouTubeURL] = useState("JRzWRZahOVU");

  return (
    <section className="py-lg-16 py-8 bg-white">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="mb-6 mb-lg-0">
            <div className="">
              <h5 className="text-dark mb-2 badge bg-light-success p-2 fw-bold">
                {/* <i className="fe fe-dollar-sign icon-xxs icon-shape bg-light-success text-success rounded-circle me-2"></i>{" "} */}
                Aumenta tu utilidad hasta en un 60% año contra año
              </h5>
              <h1 className="display-3 fw-bold mb-3">
                <span className="text-primary">Maximiza la utilidad</span> en tu gasolinera
              </h1>
              <ul className="list-unstyled mb-5">
                <li>
                  <i className="fe fe-check icon-xxs icon-shape bg-light-success text-success rounded-circle me-2"></i>{" "}
                  Pronostica el precio ideal de venta de tus combustibles
                </li>
                <li>
                  <i className="fe fe-check icon-xxs icon-shape bg-light-success text-success rounded-circle me-2"></i>{" "}
                  Monitorea a tu competencia y lleva histoico de sus precios en automático
                </li>

                <li>
                  <i className="fe fe-check icon-xxs icon-shape bg-light-success text-success rounded-circle me-2"></i>{" "}
                  Toma decisiones basadas en datos y no en corazonadas
                </li>
              </ul>
              {/* <Link to="/sign-up" className="btn btn-primary">
                Regístrate Ya
              </Link> */}
              {/* <Link
                to="#"
                onClick={() => setOpen(true)}
                className="popup-youtube fs-4 text-inherit ms-3"
              >
                <img src={PlayBtn} alt="" className="me-2" />
                Watch Demo
              </Link> */}
              {/* video popup */}
              <ModalVideo
                channel="youtube"
                autoplay
                isOpen={isOpen}
                videoId={YouTubeURL}
                onClose={() => setOpen(false)}
              />
            </div>
          </Col>
          <Col lg={6} className="d-flex justify-content-center">
            <div className="position-relative">
              <img src={GasStation} alt="" className="" style={{ width: "100%" }} />
              {/* <img
                src={GasStation}
                alt=""
                className="position-absolute end-0 bottom-0"
                style={{ width: "100%" }}
              /> */}
              {/* <img src={Frame1} alt="" className="position-absolute top-0 ms-lg-n10 ms-n19" />
              <img
                src={Frame2}
                alt=""
                className="position-absolute bottom-0 start-0 ms-lg-n14 ms-n6 mb-n7"
              /> */}
              {/* <img
                src={Target}
                alt=""
                className="position-absolute bottom-0 mb-10 ms-n10 ms-lg-n1 "
              />
              <img
                src={Sound}
                alt=""
                className="position-absolute top-0  start-0 mt-18 ms-lg-n19 ms-n8"
              />
              <img
                src={Trophy}
                alt=""
                className="position-absolute top-0  start-0 ms-lg-n14 ms-n5"
              /> */}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroAcademy;
